import { useDispatch } from "react-redux";
import { addUserSchema } from "../schema";
import { addUsersData } from "../../../store/Settings/actions";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {useState} from "react";

export const useAddUser = (state) => {
  const dispatch = useDispatch();
  const { settings_users_data } = useSelector((state) => state.settings);
  const navigate = useNavigate();

  const currUserData = Array.isArray(settings_users_data.content) && settings_users_data.content.find((user) => user.id === state?.id) || {};
  const managerInfo = Array.isArray(settings_users_data.content)
  ? settings_users_data.content.map((user) => ({
      label: `${user.firstName} ${user.lastName}`,
      value: user.id.toString(),
      id: user.id,
      version: user.version,
  }))
  : [];

  const [switches, setSwitches] = useState({
    "domestic-air-cargo": false,
    "intl-lcl": false,
    "intl-fcl": false,
    "intl-air-cargo": false,
  });

  const handleSwitchChange = (id) => {
    setSwitches({
      "domestic-air-cargo": false,
      "intl-lcl": false,
      "intl-fcl": false,
      "intl-air-cargo": false,
      [id]: true, // Only the selected switch will be true
    });
  };

  const initialValues = {
    firstName: currUserData?.firstName || "",
    lastName: currUserData?.lastName || "",
    email: currUserData?.email || "",
    roles: currUserData?.roles || [],
    password: currUserData?.password || "",
    reEnterdPassword: currUserData?.password || "",
    roleNames: currUserData?.roleNames || "",
    manager: managerInfo.find((option) => option.id === currUserData?.managerId) ,
    location: "",
    purviewType: currUserData.purviewType,
    discountPurview: currUserData.discountPurview
  };

  const handleAddUser = async (values, { resetForm }) => {
    console.log("hey I am add user:-", values);

    const payload = {
      ...(Object.keys(currUserData).length ? { id: currUserData.id, version: currUserData.version } : {}),
      firstName: values.firstName,
      lastName: values.lastName,
      managerId:values?.manager?.id,
      email: values.email,
      ...(!(state?.id) && {
        password: values.password,
      }),
      purviewType: values?.purviewType,
      discountPurview: values?.discountPurview,
      roles: values.roles,
      status: "ACTIVE",
    };

    dispatch(addUsersData(payload));
    resetForm();
    navigate('/settings/users');
  };

  return {
    initialValues,
    schema: addUserSchema,
    handleAddUser,
    handleSwitchChange,
    switches
  };
};

export default useAddUser;
